<template>
  <div class="list-view">
    <h2 class="view-title">My Collection</h2>

    <load v-if="loading" />

    <div v-else class="view-container">
      <ul v-if="groupNFT.length > 0">
        <list-nft v-for="nft in groupNFT" :key="nft.id" :nft="nft" />
        <!-- <li v-for="nft in groupNFT" :key="nft.id">
          <div class="nft-image-shadow">

            <div class="nft-image">
              <loading v-if="true" />
              <img v-else :src="nft.image" alt="">
            </div>

            <div class="granule-bg">
              <div class="granule-bg-linear"></div>
            </div>
          </div>

          <h4 class="nft-name">{{nft.name}}</h4>
        </li> -->
      </ul>

      <div v-else class="back-link">
        <personality-button
          type="form"
          @click="back"
        >
          Back
        </personality-button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { ethers } from 'ethers'
import { mapState } from 'vuex'
import Load from '@/components/common/Load.vue'
import ListNft from '@/components/List/ListNft.vue'
import PersonalityButton from '@/components/common/PersonalityButton.vue'

const NFT = function (rpcUrl = process.env.VUE_APP_RPC) {
  const provider = new ethers.providers.JsonRpcProvider(rpcUrl)
  const nftAbi = [
    'function balanceOf(address) view returns (uint)',
    'function tokenURI(uint256 _tokenId) external view returns (string)',
    'function tokenOfOwnerByIndex(address _owner, uint256 _index) external view returns (uint256)'
  ]
  const contractAddress = process.env.VUE_APP_CONTRACT
  this.contract = new ethers.Contract(contractAddress, nftAbi, provider)
}

NFT.prototype = {
  async balanceOf (address) {
    return await this.contract.balanceOf(address)
  },

  async all (address) {
    const count = await this.balanceOf(address)
    const promises = []
    for (let i = 0; i < count; i++) {
      const promise = this.contract
        .tokenOfOwnerByIndex(address, i)
        .then((tokenId) => this.contract.tokenURI(tokenId))
        .then((uri) => uri.substring(29)) // data:application/json;base64,
        .then(atob)
        .then(JSON.parse)
      promises.push(promise)
    }
    return Promise.all(promises)
  }
}

const nft = new NFT()

export default defineComponent({
  components: { Load, ListNft, PersonalityButton },
  data: function () {
    return {
      address: '',
      count: 0,
      message: '',
      nfts: [],
      loading: true
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo
    }),
    groupNFT () {
      const values = this.nfts.map((item) => {
        item.image = `https://ipfs.infura.io/ipfs/${item.image.substring(7)}`
        return item
      })
      // .reduce((prev, current) => {
      //   for (const attribute of current.attributes) {
      //     if (attribute.trait_type === 'spaceman') {
      //       const value = attribute.value
      //       if (prev[value]) {
      //         prev[value].count++
      //         prev[value].all.push(current)
      //       } else {
      //         prev[value] = {
      //           image: current.image,
      //           count: 1,
      //           all: [current],
      //           id: value
      //         }
      //       }
      //     }
      //   }
      //   return prev
      // }, {})

      // const result = []
      // for (const name in values) {
      //   result.push(values[name])
      // }
      // return result

      return values
    }
  },

  methods: {
    async getInfo () {
      try {
        this.message = `loading address ${this.address} nft count`
        const count = await nft.balanceOf(this.address)
        this.count = count
        this.message = 'loading details...'
        const allNFT = await nft.all(this.address)
        console.table(allNFT)
        this.nfts = allNFT
        this.message = ''

        this.loading = false
      } catch (e) {
        this.message = `${e}`
      }
    },

    back () {
      this.$router.push({
        name: 'CreateRedPack'
      })
    }
  },

  mounted () {
    if (this.userInfo.address) {
      this.address = this.userInfo.address
      this.getInfo()
    } else {
      this.$router.push({
        name: 'CreateRedPack'
      })
    }
  }
})
</script>

<style lang="scss" scoped>
$list-count: 3;
$list-margin: 56px;
$list-width: 328px;

.list-view {
  .view-title {
    text-align: center;
  }

  .view-container {
    display: flex;
    justify-content: center;
  }

  ul {
    margin-top: 48px;
    display: flex;
    flex-wrap: wrap;
    padding: 0 calc((100% - $list-width * 3 - $list-margin * 2) / 2);

    .list-nft {
      width: $list-width;
      margin-bottom: $list-margin;

      &:not(:nth-child(3n - 2)) {
        margin-left: $list-margin;
      }
    }
  }

  ul,
  li {
    list-style: none;
  }

  .back-link {
    margin-top: 48px;
  }

  .personality-button {
    width: 327px;
  }
}
</style>
